<gatewee-content-page
  [breadcrumb]="[
    {label: 'nav.menu.home' | translate, path: '/panel'},
    {label: 'nav.menu.myFees' | translate}
  ]"
  [title]="'nav.menu.myFees' | translate"
>
  <div page-body>
    <div *ngIf="isLoading" class="gw-text-text-secondary">
      {{ 'features.myFees.loading' | translate }}
    </div>

    <div *ngIf="!isLoading && hasError" class="gw-text-status-negative">
      {{ 'features.myFees.error' | translate }}
    </div>

    <ng-container *ngIf="!isLoading && !hasError">
      <ng-container *ngIf="hasAssociatedFees; else recipientNoFees">
        <gatewee-fee-snapshot-table
          [feeSnapshot]="feeSnapshot"
        ></gatewee-fee-snapshot-table>
      </ng-container>
    </ng-container>

    <ng-template #recipientNoFees>
      <div class="gw-text-center gw-py-2x-large">
        <gatewee-icon
          [icon]="'@tui.percent'"
          class="gw-text-4xl gw-text-text-secondary gw-mb-medium gw-inline-flex"
        ></gatewee-icon>
        <p class="gw-text-text-secondary">
          {{ 'features.myFees.recipient.noAssociation' | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</gatewee-content-page>
